.actionLink {
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 var(--ant-padding-xs);
}

.messageRow {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  margin-bottom: 8px;
}

.messageRowOwner {
  flex-direction: row-reverse;
}

.messageColumn {
  display: flex;
  flex-direction: column;
  max-width: 75%;
  min-width: 0;
}

.messageColumnOwner {
  align-items: flex-end;
}

.bubbleMeta {
  font-size: 11px;
  margin-bottom: 4px;
}

.bubble {
  width: fit-content;
  max-width: 100%;
  padding: 10px 14px;
  border-radius: 18px;
  background-color: var(--ant-color-fill-secondary);
  word-break: break-word;
}

.bubbleOwner {
  background-color: var(--ant-color-primary);
}

.bubbleOwner :global(.ant-typography) {
  color: var(--ant-color-text-light-solid);
}

.messageActions {
  display: flex;
  gap: 4px;
  margin-top: 4px;
}
